/**
 * Calidad mínima de la foto del contribuyente (editor RecorteFotoModal).
 *
 * La foto final siempre es un recorte 3:4 de la imagen elegida. Para que se vea bien en el carnet tiene que
 * tener, como mínimo, 300 × 400 píxeles reales; lo recomendable es 400 × 533.
 *  - Aviso (no bloquea): si la foto elegida no llega a 300 × 400, ni siquiera sin zoom sale con ese tamaño.
 *  - Tope de zoom: nunca se deja acercar tanto que el recorte resultante baje de 300 × 400. Si la foto original
 *    ya es menor, no se limita nada (solo se avisa): no tiene sentido impedir algo que ya no se puede cumplir.
 */

export const FOTO_MIN_ANCHO = 300;
export const FOTO_MIN_ALTO = 400;
export const FOTO_RECOMENDADA_ANCHO = 400;
export const FOTO_RECOMENDADA_ALTO = 533;
export const ZOOM_MAXIMO_EDITOR = 3;

export const MENSAJE_FOTO_CHICA = `La foto es muy chica y se va a ver borrosa en el carnet. Usá una de al menos ${FOTO_RECOMENDADA_ANCHO} × ${FOTO_RECOMENDADA_ALTO} píxeles.`;

const ASPECTO = 3 / 4;

/** Tamaño (px reales) del recorte 3:4 más grande posible de una imagen, o sea el resultado con el zoom al mínimo. */
export function tamanoSinZoom(ancho, alto) {
  const w = Number(ancho) || 0;
  const h = Number(alto) || 0;
  if (w <= 0 || h <= 0) return { ancho: 0, alto: 0 };
  const anchoRecorte = Math.min(w, h * ASPECTO);
  return { ancho: Math.round(anchoRecorte), alto: Math.round(anchoRecorte / ASPECTO) };
}

/** true si la imagen no alcanza 300 × 400 (aun sin zoom, el resultado quedaría por debajo). */
export function fotoEsMuyChica(ancho, alto) {
  const w = Number(ancho) || 0;
  const h = Number(alto) || 0;
  if (w <= 0 || h <= 0) return false; // todavía no se sabe: no avisar
  const { ancho: aw, alto: ah } = tamanoSinZoom(w, h);
  return aw < FOTO_MIN_ANCHO || ah < FOTO_MIN_ALTO;
}

/**
 * Zoom máximo que deja el recorte en 300 × 400 reales o más. Para una foto ya chica, o todavía sin medir,
 * devuelve el tope general (sin limitar). Nunca baja de 1; redondea hacia abajo a 2 decimales para no pasarse.
 */
export function zoomMaximoPermitido(ancho, alto, tope = ZOOM_MAXIMO_EDITOR) {
  const w = Number(ancho) || 0;
  const h = Number(alto) || 0;
  if (w <= 0 || h <= 0 || fotoEsMuyChica(w, h)) return tope;
  const { ancho: aw } = tamanoSinZoom(w, h);
  const z = Math.floor((aw / FOTO_MIN_ANCHO) * 100) / 100;
  return Math.max(1, Math.min(tope, z));
}
